import React from 'react';
import { useRouter, NextRouter } from 'next/router';
import { uniqBy } from 'lodash';
import { withTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { TestId } from '@components/test-ids';
import { Grid } from '@mui/material';
import { Theme } from '@theme/base';
import { TripTypes } from '@model/common';
import { TourResult } from '@model/tours';
import { TourDealFinderTile, TourGhostTile } from '@components/product/tour-product-tile';
import { LoadMore } from '@components/search-results/deal-finder-results/results-grid/LoadMore';
import { sanitiseParams } from '@util/common';

export interface TourResultsGridProps {
  theme?: Theme;
  tourSearchResults: Array<TourResult>;
  tripType: TripTypes;
  searchToken?: string;
  isGhosting?: boolean;
  isLoadingMore: boolean;
  isMoreAvailable: boolean;
  onLoadMore: () => void;
}

const Container = styled.div({});

export const TourResultsGridComponent = ({
  theme,
  tourSearchResults,
  tripType,
  searchToken,
  isGhosting,
  isLoadingMore,
  isMoreAvailable,
  onLoadMore
}: TourResultsGridProps) => {
  const router: NextRouter = useRouter();
  const sanitised = sanitiseParams(router.query);

  /* *** RENDERERS *** */
  const renderSearchResults = () =>
    isGhosting
      ? Array(12)
          .fill(null)
          .map((_, index) => (
            <Grid item xs={12} md={6} lg={4} xl={3} key={index}>
              <TourGhostTile />
            </Grid>
          ))
      : uniqBy(tourSearchResults, ({ summary }) => summary.place.tour?.name.path).map((tourResult: TourResult) => {
          return (
            <Grid item xs={12} md={6} lg={4} xl={3} key={tourResult.summary.place?.tour?.name.path}>
              <TourDealFinderTile
                testId={TestId.tourResultsGrid.resultTile}
                tour={tourResult}
                tripType={tripType}
                searchToken={searchToken}
                query={sanitised}
              />
            </Grid>
          );
        });

  return (
    <Container data-testid={TestId.tourResultsGrid.main}>
      <Grid container spacing={theme!.custom.gridSpacing.default}>
        {renderSearchResults()}
      </Grid>
      <LoadMore isLoadingMore={isLoadingMore} isMoreAvailable={isMoreAvailable} onLoadMore={onLoadMore} />
    </Container>
  );
};

export const TourResultsGrid = withTheme(TourResultsGridComponent);
